<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mLisa4/tc-custom/9781250199928.jpg?1725275587489" alt="This image is the cover for the book Anything for You, Valerie Hart"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Anything for You, Valerie Hart
      </h1>
      <p class="bookDescription body article font2">
        <b>A detective must reckon with her past and future as she probes a lawyer’s grisly murder in this crime thriller by the author of <i>The Killing Lessons</i>.</b><br/><br/>On a hot summer night, a watchful neighbor locks eyes with an intruder and unwittingly alerts the police to a vicious crime scene next door: a lavish master bedroom where a man lies dead. Next to him, his wife is bleeding out onto the hardwood floor, clinging to life.<br/><br/>The victim, Adam Grant, was a well-known San Francisco prosecutor—a man whose connection to homicide detective Valerie Hart brings her face-to-face with a life she’s long since left behind. Adam’s career made him an easy target, and forensic evidence points towards an ex-con he put behind bars years ago. But while Adam’s wife and daughter grapple with their tragic loss, Valerie uncovers devastating clues that point in a more ominous direction. Lurking in the shadows of the Grants’ pristine life is a mysterious blonde who holds the key to a very different—and much darker—story . . . <br/><br/>As Valerie struggles to forge a new path for herself, the investigation forces her to confront the question: can we ever really leave our pasts behind?<br/><br/><b>Praise for <i>Anything for You</i></b><br/><br/>“[A] hard as nails detective novel, satisfyingly twisted story, and the writing is sharp as the devil.” —Stephen King<br/><br/>“A rare thriller that picks up both style and momentum as the pages fly. A first-rate suspense novel.” —Peter Blauner, bestselling author of <i>Sunrise Highway</i><br/><br/>“Gritty and grim, this is a terrific thriller made more luminous by its refreshingly human detective.” —<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Saul Black
      </h2>
      
      <p class="authorDescription body article">SAUL BLACK is the author of <I>The Killing Lessons</I> and <I>LoveMurder</I>. He lives in London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cd5be532